<input type="file" #fileInput accept=".json" style="display:none" (change)="onFileSelected($event)" />

@if (mode === 'select') {
<div class="dialog-content">
  <h3 class="dialog-title">Import Organisation</h3>
  <p class="dialog-subtitle">Select a JSON file exported from the organisation list.</p>
  <div class="drop-zone" (click)="browseFile()">
    <mat-icon class="drop-icon">upload_file</mat-icon>
    <span>Click to browse for a <strong>.json</strong> export file</span>
  </div>
  <div class="action-row">
    <button mat-raised-button (click)="close()">Cancel</button>
  </div>
</div>
}

@if (mode === 'preview') {
<div class="dialog-content tall">
  <h3 class="dialog-title">Preview Import</h3>
  <p class="dialog-subtitle">Review the details below before importing.</p>
  <div class="dialog-body">
  <table class="preview-table">
    <tr>
      <td class="label">Organisation</td>
      <td class="value"><strong>{{ orgName }}</strong> ({{ orgId }})</td>
    </tr>
    <tr>
      <td class="label">Export version</td>
      <td class="value">{{ exportVersion }}</td>
    </tr>
    <tr>
      <td class="label">Exported at</td>
      <td class="value">{{ exportedAt | date: 'dd/MM/yyyy HH:mm' }}</td>
    </tr>
    <tr>
      <td class="label">Exported by</td>
      <td class="value">{{ exportedBy }}</td>
    </tr>
    @for (row of collectionRows; track row.label) {
    <tr>
      <td class="label">{{ row.label }}</td>
      <td class="value">{{ row.count }}</td>
    </tr>
    }
  </table>
  @if (duplicateOrgError) {
  <div class="warning-banner">
    <mat-icon class="warn-icon">warning</mat-icon>
    {{ duplicateOrgError }}
  </div>
  } @else {
  <p class="warning-text">
    <mat-icon class="warn-icon">warning</mat-icon>
    This will fail if an organisation with the same ID already exists.
  </p>
  }
  </div>
  <div class="action-row">
    <button mat-raised-button (click)="resetToSelect()">Back</button>
    <button mat-raised-button color="primary" [disabled]="!!duplicateOrgError" (click)="confirmImport()">Import</button>
  </div>
</div>
}

@if (mode === 'importing') {
<div class="dialog-content centered">
  <mat-spinner diameter="48"></mat-spinner>
  <p class="status-text">Importing organisation data…</p>
</div>
}

@if (mode === 'success') {
<div class="dialog-content tall">
  <div class="success-header">
    <mat-icon class="success-icon">check_circle</mat-icon>
    <h3 class="dialog-title">Import Complete</h3>
    <p class="status-text">Organisation <strong>{{ orgName }}</strong> has been imported.</p>
  </div>

  <div class="dialog-body">
  @if (hasFailed) {
  <div class="warning-banner">
    <mat-icon class="warn-icon">warning</mat-icon>
    Some items failed to import — check server logs for details.
  </div>
  }

  @if (entitySummaryRows.length > 0) {
  <table class="summary-table">
    <thead>
      <tr>
        <th class="col-entity">Entity</th>
        <th class="col-num">Imported</th>
        <th class="col-num">Skipped</th>
        <th class="col-num">Failed</th>
      </tr>
    </thead>
    <tbody>
      @for (row of entitySummaryRows; track row.label) {
      <tr [class.has-failed]="row.failed > 0">
        <td>{{ row.label }}</td>
        <td class="col-num">{{ row.imported }}</td>
        <td class="col-num">{{ row.skipped }}</td>
        <td class="col-num" [class.failed-col]="row.failed > 0">{{ row.failed > 0 ? row.failed : '—' }}</td>
      </tr>
      }
    </tbody>
  </table>
  }
  </div>

  <div class="action-row justify-center">
    <button mat-raised-button color="primary" (click)="close()">Done</button>
  </div>
</div>
}

@if (mode === 'error') {
<div class="dialog-content centered">
  <mat-icon class="error-icon">error</mat-icon>
  <h3 class="dialog-title">Import Failed</h3>
  <p class="status-text error-msg">{{ errorMessage }}</p>
  <div class="action-row justify-center">
    <button mat-raised-button (click)="resetToSelect()">Try Again</button>
    <button mat-raised-button (click)="close()">Close</button>
  </div>
</div>
}
